import React from 'react';
import cn from 'classnames';
import IconTooltip from '../iconTooltip/iconTooltip';
import styles from './styles.css';

const HelpIconTooltip = ({ className, ...props }) => {
  return <IconTooltip icon="question-circle" className={cn(styles.icon, className)} {...props} />;
};

export default HelpIconTooltip;



// WEBPACK FOOTER //
// ./src/components/helpIconTooltip/helpIconTooltip.jsx